"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermCard = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./TermCard.css"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _Provider = require("../Provider");
var _Features = require("../Features");
var _Price = require("../Price");
var _preparePromo = require("./utils/preparePromo");
var _trackPaymentClick = require("../../tracking/trackPaymentClick");
var _clsx = _interopRequireDefault(require("clsx"));
var _context = require("../../context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TermCard = props => {
  const {
    method,
    linkedPromos,
    type,
    setPreparedPromo,
    setIsFulllPriceMethod,
    fullCreditPriceTooltip
  } = props;
  const deviceType = (0, _uiKit.useDeviceType)();
  const {
    isHoverDisabled
  } = React.useContext(_context.HoverContext);
  const preparedPromo = React.useMemo(() => {
    return (0, _preparePromo.preparePromo)(method, linkedPromos);
  }, [method, linkedPromos]);
  const handleOpen = React.useCallback(() => {
    setPreparedPromo(preparedPromo);
    setIsFulllPriceMethod(type === 'fullPayment');
    (0, _trackPaymentClick.trackPaymentClick)(type, method.dialog.isBankMortgage);
  }, [type, preparedPromo, setPreparedPromo, setIsFulllPriceMethod]);
  const [hovered, setHovered] = React.useState(false);
  const handleMouseEnter = React.useCallback(() => {
    if (deviceType === 'phone' || isHoverDisabled) {
      return;
    }
    setHovered(true);
  }, [deviceType, isHoverDisabled]);
  const handleMouseLeave = React.useCallback(() => {
    setHovered(false);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['term-card'], hovered && style['term-card--hovered']),
    onClick: handleOpen,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClickCapture: handleMouseLeave
  }, /*#__PURE__*/React.createElement("div", {
    className: style['header']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['content']
  }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, method.name)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading3, {
    color: hovered ? 'text-main-default' : 'text-primary-default'
  }, method.name)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true,
    tablet: true
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "text-secondary-default"
  }, method.subtite)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_Provider.Provider, {
    providers: method.allProviders
  })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true,
    tablet: true
  }, type !== 'fullPayment' && /*#__PURE__*/React.createElement(_Provider.Provider, {
    providers: method.allProviders
  })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, method.subtite && /*#__PURE__*/React.createElement("div", {
    className: style['subtitle']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "text-secondary-default"
  }, method.subtite))), /*#__PURE__*/React.createElement(_Features.Features, {
    features: method.promoProps,
    fullCreditPriceTooltip: fullCreditPriceTooltip,
    isBankMortgage: method.dialog.isBankMortgage
  })), /*#__PURE__*/React.createElement("div", {
    className: style['icon']
  }, /*#__PURE__*/React.createElement(_icons.IconActionMore16, {
    color: "icon-main-default"
  })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: style['price--desktop']
  }, /*#__PURE__*/React.createElement(_Price.Price, {
    price: method.price,
    oldPrice: method.oldPrice,
    monthlyPrice: method.monthPayment,
    promoLabel: method.linkedPromosCount,
    discountLabel: method.discountLabel,
    bankMortgageLabel: method.bankMortgageLabel
  })))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true,
    tablet: true
  }, /*#__PURE__*/React.createElement(_Price.Price, {
    price: method.price,
    oldPrice: method.oldPrice,
    monthlyPrice: method.monthPayment,
    promoLabel: method.linkedPromosCount,
    bankMortgageLabel: method.bankMortgageLabel
  })));
};
exports.TermCard = TermCard;